import { render, staticRenderFns } from "./SelectNutzergruppen.vue?vue&type=template&id=245762bc"
import script from "./SelectNutzergruppen.vue?vue&type=script&lang=js"
export * from "./SelectNutzergruppen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports